module.exports = __webpack_public_path__ + "img/GL_bg.031b9a15.jpg";